import { render, staticRenderFns } from "./mBtn.vue?vue&type=template&id=71c0fad2&scoped=true&"
import script from "./mBtn.vue?vue&type=script&lang=js&"
export * from "./mBtn.vue?vue&type=script&lang=js&"
import style0 from "./mBtn.vue?vue&type=style&index=0&id=71c0fad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0fad2",
  null
  
)

export default component.exports